<template>
  <GmapMap
    :center="mapCenter"
    :zoom="15"
    style="width: 100%; height: 400px"
    class="deliveryProofMaps"
  >
    <GmapMarker
      v-if="expectedLatLng"
      :position="expectedLatLng"
      icon="https://storage.googleapis.com/carrier-logotypes/enviatrack/destination.png"
      @click="showExpectedInfo = !showExpectedInfo"
    >
      <GmapInfoWindow
        v-if="showExpectedInfo"
        :position="expectedLatLng"
        @closeclick="showExpectedInfo = false"
      >
        <div>
          <strong>Dirección de entrega</strong><br>
          <span>{{ expectedAddress }}</span>
        </div>
      </GmapInfoWindow>
    </GmapMarker>

    <GmapMarker
      v-if="deliveryLatLng"
      :position="deliveryLatLng"
      icon="https://storage.googleapis.com/carrier-logotypes/enviatrack/delivered_correct.png"
      @click="toggleDeliveredInfo"
    >
      <GmapInfoWindow
        v-if="showDeliveredInfo"
        :position="deliveryLatLng"
        @closeclick="showDeliveredInfo = false"
      >
        <div>
          <strong>Entregado en</strong><br>
          <span>{{ deliveredAddress }}</span>
        </div>
      </GmapInfoWindow>
    </GmapMarker>
  </GmapMap>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'DeliveryMap',
  props: {
    deliveryLocation: {
      type: Object,
      required: true
    },
    expectedLocation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      expectedLatLng: null,
      deliveryLatLng: null,
      showExpectedInfo: false,
      expectedAddress: '',
      showDeliveredInfo: false,
      deliveredAddress: '',
      isDeliveryAddressReady: false
    }
  },
  computed: {
    google: gmapApi,
    mapCenter() {
      return this.deliveryLatLng || this.expectedLatLng || { lat: 0, lng: 0 }
    }
  },
  watch: {
    expectedLocation: {
      handler() {
        this.setExpectedLocation()
      },
      immediate: true
    },
    deliveryLocation: {
      handler(newVal) {
        if (!this.m_isNotEmpty(newVal)) return
        this.setDeliveryLocation(newVal)
      },
      immediate: true
    }
  },
  methods: {
    setExpectedLocation() {
      setTimeout(() => {
        this.expectedAddress = `${this.expectedLocation.full_address}, ${this.expectedLocation.place_name}`
        if (this.expectedLocation.latitude && this.expectedLocation.longitude) {
          this.expectedLatLng = {
            lat: parseFloat(this.expectedLocation.latitude),
            lng: parseFloat(this.expectedLocation.longitude)
          }
        } else if (this.expectedLocation.full_address) {
          const geocoder = new this.google.maps.Geocoder()
          const address = `${this.expectedLocation.full_address}, ${this.expectedLocation.place_name}`

          geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results[0]) {
              this.expectedLatLng = {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng()
              }
            } else {
              console.error('Geocoding failed:', status)
            }
          })
        }
      }, 1000)
    },
    setDeliveryLocation(data) {
      if (data?.lat || data?.lng) {
        this.deliveryLatLng = {
          lat: parseFloat(data.lat),
          lng: parseFloat(data.lng)
        }
        this.reverseGeocodeDelivery()
      }
    },
    reverseGeocodeDelivery() {
      setTimeout(() => {
        const geocoder = new this.google.maps.Geocoder()
        geocoder.geocode({ location: this.deliveryLatLng }, (results, status) => {
          if (status === 'OK' && results[0]) {
            this.deliveredAddress = results[0].formatted_address
            this.isDeliveryAddressReady = true
          } else {
            console.error('Reverse geocoding failed:', status)
          }
        })
      }, 1000)
    },
    toggleDeliveredInfo() {
      if (this.isDeliveryAddressReady) {
        this.showDeliveredInfo = !this.showDeliveredInfo
      } else {
        this.reverseGeocodeDelivery()
      }
    }
  }
}
</script>

<style scoped>
#map {
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>

<style>
.deliveryProofMaps .gm-ui-hover-effect {
  width: 1rem !important;
  height: 1rem !important;
}
.deliveryProofMaps .gm-ui-hover-effect > span {
  margin: 0 !important;
  margin-right: 5px;
}
.deliveryProofMaps .gm-style-iw-chr button {
  padding-top: 5px !important;
  width: 20px !important;
  height: 20px !important;
}
</style>
